import { isNil } from "lodash-es";
import { ensure, numberType, stringType, TType } from "types";

import { idType, IId } from "@/core/api";
import { configInvitationType, IInvitation } from "@/data/invitations/types";

export interface IPersonalInvitationContact {
  contactEmail: string;
  contactFirstName: string;
  contactLastName: string;
}

export const configPersonalInvitationContact: TType<IPersonalInvitationContact> = {
  contactEmail: stringType(""),
  contactFirstName: stringType(""),
  contactLastName: stringType(""),
};

export interface IPersonalInvitation extends IInvitation {
  contactPerson: IPersonalInvitationContact;
  jobRequestApplication: IId | null;
  recommendedJobRequestId: number;
}

export interface IRegisterPersonalInvitationDto extends Pick<IPersonalInvitation, "firstName" | "lastName" | "email"> {
  token: string;
  password: string;
  confirmPassword: string;
}

const configPersonalInvitationType: TType<IPersonalInvitation> = {
  ...configInvitationType,
  contactPerson: ensure(configPersonalInvitationContact),
  jobRequestApplication: v => (isNil(v) ? v : idType(v)),
  recommendedJobRequestId: numberType(NaN),
};

export const personalInvitationType = ensure(configPersonalInvitationType);
